import './main.css';
import { Link } from "react-scroll";
import React from 'react';
import { InlineShareButtons } from 'sharethis-reactjs';
import creative from '../../img/main/creative.png'
import creative_mob from '../../img/main/creative-mob.png'
import Marquee from 'react-double-marquee';


export default class Main extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            firstScreenHeight: document.documentElement.clientHeight,
        }

        this.changeScreenHeight = this.changeScreenHeight.bind(this);
    }

    changeScreenHeight() {
        this.setState({
            firstScreenHeight: document.documentElement.clientHeight
        });

        document.querySelector('.main_wrap').style.height = this.state.firstScreenHeight + 'px';
    }

    componentWillMount = () => {
        window.addEventListener("resize", this.changeScreenHeight);
        return () => window.removeEventListener("resize", this.changeScreenHeight);
    }

    componentDidMount() {
        this.changeScreenHeight();
    }

    render() {
        return (
            <div className='main_wrap'>
                <div className='main_bg'></div>
                <div className='container main_block'>
                    <div className='main_content main_item'>
                        <h1 className='main_title'>Flutter<br />Global Summit’24</h1>
                        <div className="main_img_block main_img_block--mob main_item">
                            {/* <img className="main_img" src={creative_mob} alt="" /> */}
                            <img className="main_img" src={creative} alt="" />
                        </div>
                        <p className='main_descr main_descr-data'>Online Summit for Flutter Developers</p>
                        <p className='main_descr'>February 27-28, 2024</p>
                        <div className='main_btns_wrap'>
                            <Link
                                activeClass="active"
                                to='tickets'
                                spy={true}
                                smooth={true}
                                offset={80}
                                className='main_btn button'
                            >
                                GET TICKET
                            </Link>
                            <InlineShareButtons
                                className='main_button main_btn--share'
                                config={{
                                    alignment: 'center',  // alignment of buttons (left, center, right)
                                    color: 'transparent',      // set the color of buttons (social, white)
                                    enabled: true,        // show/hide buttons (true, false)
                                    font_size: 16,        // font size for the buttons
                                    labels: 'cta',        // button labels (cta, counts, null)
                                    language: 'en',       // which language to use (see LANGUAGES)
                                    networks: [           // which networks to include (see SHARING NETWORKS)
                                        'sharethis'
                                    ],
                                    padding: 12,          // padding within buttons (INTEGER)
                                    radius: 0,            // the corner radius on each button (INTEGER)
                                    size: 49,             // the size of each button (INTEGER)

                                    // OPTIONAL PARAMETERS
                                    url: 'https://events.geekle.us/flutter23/?utm_source=website&utm_medium=sharelink', // (defaults to current url)
                                    description: 'Anything, that you have to know about Flutter in 2023',       // (defaults to og:description or twitter:description)
                                    title: `Flutter Global Summit'23`,            // (defaults to og:title or twitter:title)
                                }}
                            />
                        </div>
                    </div>
                    {/* <div className="main_img_block main_img_block--pc main_item">
                        <img className="main_img" src={creative} alt="" />
                    </div> */}
                    {/* <div className="main_video main_item">
                        <ReactPlayer
                        url={video_vue}
                        width="100%"
                        height="auto"
                        playing
                        controls
                        playIcon={<button className='videoPresent_item-play'></button>}
                        light={video_preview}
                        />
                    </div> */}
                </div>
                <img className="main_img main_img-desc" src={creative} alt="" />
                <div className='main_anim'>
                    <Marquee direction='left' speed={0.03} delay={0} childMargin={0}>
                        <span className="purple"> Flutter Global Summit’24</span>
                        <span> Flutter Global Summit’24</span>
                        <span className="purple"> Flutter Global Summit’24</span>
                        <span> Flutter Global Summit’24</span>
                        <span className="purple"> Flutter Global Summit’24</span>
                        <span> Flutter Global Summit’24</span>
                        <span className="purple"> Flutter Global Summit’24</span>
                        <span> Flutter Global Summit’24</span>
                        <span className="purple"> Flutter Global Summit’24</span>
                        <span> Flutter Global Summit’24</span>
                    </Marquee>
                </div>
            </div>
        )
    }
}